<template>
  <content-div>

    <step-bar :step="step" title="차량정보 입력 및 멤버십 선택"></step-bar>

    <div class="contArea">

      <ul class="formList">
        
        <radio-input
            ref='vehicleNum'
            :title="vehicleNumId.title"
            :description="vehicleNumId.description"
            :items="vehicleNumId.items"
            :selected="selected.vehicleNumId"
            :val.sync="selected.vehicleNumId"
            :option-val-id="true"
            >
        </radio-input>
        
        <li class="mb20px">
          <a v-if="!selected.vehicleNumId" class="btnL" @click="activateVehicle = true">차량 등록하기</a>
          
          <div v-else class="vehicleWrap">
            <div class="stepTxt"> + </div>
            <a class="stepTit" @click="activateVehicle = true">차량 등록하기</a>
          </div>

        </li>

        <select-box
            title="차량을 선택해주세요."
            :items="vehicleSelectData"
            :selected="selected.vehicle"
            :val.sync="selected.vehicle"
            :option-val-id="true"
            :closed="true"
            :disable="vehicleSelectData.length === 0 || vehicleSelectData && vehicleSelectData[0].isEmpty"
        ></select-box>

        <select-box
            title="멤버십을 선택해주세요."
            :items="pkgs"
            :selected="selected.pkg"
            :val.sync="selected.pkg"
            :closed="true"
        ></select-box>

        <!-- v-if="pkgs[selected.pkg] !== undefined && pkgs[selected.pkg].is_assurance" -->
        <select-box
            title="최초등록일 입력해주세요."
            input_type="date"
            :date.sync="selected.date"
            :val.sync="selected.term"
            :setDate.sync="selected.setDate"
        >
        </select-box>
        
      </ul>

      <button-apply before="/subscApply/vehicle" @submit="validate"></button-apply>

      <popup-alert v-if="activate" title="알림" @close="popupClose">
        <popup-msg :type="popupMsg"></popup-msg>
      </popup-alert>

      <popup-apply-survey
          v-if="activateApplySurvey"
          @close="applySurveyClose">
      </popup-apply-survey>

      <popup-full v-if="activateVehicle" @close="openUsePopup()" >
          <template #title>내 차량 등록</template>

          <template #content>
            <div class="inputLabel2">차량조회</div>
            <text-input-form
                title="차대번호"
                ref='vehicleNum'
                description="차량 등록증에 있는 차대번호 17자리를 확인하시고 입력해주세요."
                :col="3"
                :data="vehicleNumId">
              <text-input :data="vehicleNumId" :max="17" :disable="false"></text-input>
            </text-input-form>
            <div class="mb20px">
              <a class="btnL" @click="getDmsVehicleInfo(true)">조회</a>
            </div>

            <table v-if="dmsVehicleData" class="tbl-form alignL pm-tbl-form">
              <tbody class="dmsVehicleTbody">
                <tr>
                  <th>차대번호</th>
                  <td>{{ dmsVehicleData.vinNo }}</td>
                </tr>
                <tr>
                  <th>차량정보</th>
                  <td>{{ dmsVehicleData.modelNm }}</td>
                </tr>
              </tbody>
            </table>

            <div v-if="dmsVehicleData" class="mb20px">
              <a class="btnL" @click="setVehicleInfo()">등록</a>
            </div>

          </template>
      </popup-full>

    </div>
  </content-div>
</template>


<script>
import {api} from '../../../api';
import axios from 'axios';
import Const from "../../../helpers/Const";
import Format from "../../../helpers/Format";

import { PromoMixin } from '@/mixins/PromoMixin';

import StepBar from '@/components/StepBar.vue';
import SelectBox from "@/components/Select/SelectBox";

import PkgTabProdFtdList from '@/views/Pkg/PkgTabProdFtdListView.vue'
import PkgTabProdListView from "@/views/Pkg/PkgTabProdListView";

import TextInput from "@/components/Input/TextInput";
import TextInputForm from '@/components/Input/TextInputForm.vue';

import RadioInput from '@/components/Input/RadioInput.vue';

import ButtonApply from "@/components/Button/ButtonSubscApply.vue";

import PopupAlert from '../../../components/Popup/PopupAlert.vue';
import PopupMsg from "../../../components/Popup/PopupMsgTemplate";
import PopupApplySurvey from "../../../components/Popup/PopupApplySurvey";
import PopupFull from '@/components/Popup/PopupFull.vue'


export default {
  mixins:[PromoMixin],

  beforeRouteEnter(to, from, next) {
    // subscStatus는 연장신청의 경우 해당 경로로 접근
    // if (
    //     from.name != 'SubscApplyTerm' &&         //구독 차량 정보 입력
    //     from.name != 'SubscApplyVehicle' &&         //구독 차량 정보 입력
    //     from.name != 'SubscApplyTermInsurance' &&   //구독 보험 약관 동의
    //     from.name != 'SubscApplyReq' &&             //구독 결제 화면
    //     from.name != 'Subsc'                        //구독 현황 (연장신청)
    // ) {
    //   alert('잘못된 접근경로 입니다.');
    //   this.$store.commit("unsetTerms");
    //   next('/')
    // } else {
    next();
    // }
  },

  components: {
    StepBar,
    SelectBox,
    PkgTabProdFtdList,
    PkgTabProdListView,
    ButtonApply,
    PopupAlert,
    PopupMsg,
    PopupApplySurvey,
    PopupFull,
    TextInput,
    TextInputForm,
    RadioInput,
  },

  computed: {
    costState() {
      let state = false;
      const vehicleData = this.vehicleCats[this.selected.pkg][this.selected.vehicle];
      if (vehicleData) {
        const cost = vehicleData.costs[this.selected.term];
        if(cost) state = cost.state;
      }
      return state;
    },

    costPromo() {
      let promoType = 'promo';
      if (this.$store.state.subsc.state_req == Const.SUBSC_STATE_REQ.ENABLE_EXT)
        promoType = 'promo_extend';
      let discount = 0;
      if (this.pkgs[this.selected.pkg][promoType])
        discount = this.setPromoRate(this.pkgs[this.selected.pkg][promoType], this.costService);
      return discount;
    },

    costService() {
      let price = 0;
      const vehicleData = this.vehicleCats[this.selected.pkg][this.selected.vehicle];
      if (vehicleData) {
        const cost = vehicleData.costs[this.selected.term];
        price = cost.year;
      }
      return price;
    },

    terms() { return this.getSubscPeriod(); },
    isAssurance(){ return this.pkgs[this.selected.pkg].is_assurance;},
  },

  updated: function(){
    let ref = this
    this.$nextTick(function () {
      if(ref.$refs['vehicleNum'] !== undefined){
        if (this.$store.state.vehicle.num_id !== ''){
          //this.vehicleNumId.val = this.$store.state.vehicle.num_id;
        }
      }
    })
  },

  mounted() {

    this.step = Number(this.$route.query.step || (this.$store.state.subsc.payments.step-1));
    this.dmsVehicleData = null;

    window.scroll(0, 0);
    this.$store.commit("setTerm", { insurance_survey: false });

    if(this.$store.state.vehicle.num_id) {
      this.vehicleNumId.items.push({
        id:this.$store.state.vehicle.num_id,
        title:this.$store.state.vehicle.num_id
      });
    }

    // 페키지
    if(this.$store.state.pkg.id){
      this.selected.pkg = this.$store.state.pkg.id;
    } else {
      this.selected.pkg = this.$route.query.pkg;
    }

    //날짜
    if (this.$store.state.vehicle.date_reg_cdk !== ''){
      this.selected.date = this.$store.state.vehicle.date_reg_cdk;
    } else if(this.$route.query.date && this.$route.query.date !== 'null') {
      this.selected.date = this.$route.query.date;
    } else {
      const currentDate = new Date();
      const previousDate = new Date(currentDate);
      previousDate.setMonth(currentDate.getMonth() - 60);
      this.selected.setDate = previousDate.toISOString();
    }

    this.selected.term = this.$route.query.term;

    this.selected.vehicle = this.$store.state.vehicle.vehicle_cat_id;

    this.setPkg();
    this.getOasVehicleInfos();
  },

  data() {
    return {
      step: 0,
      pkgs: this.$store.state.pkgs,
      prods: this.$store.state.prods,
      vehicleCats: this.$store.state.vehicleCats,
      vehicleModelType: this.$store.state.vehicle.model.type,
      vehicleNumId: {
        title: '차대번호를 선택해주세요.',
        items: [],
        val: '',
        cnt: 17,
        func:{name:'validateNo'},
        description: null,
      },

      selected: {
        pkg: null,
        vehicle: 0,
        vehicleNumId: '',
        wdmsInfo: null,
        type: 0,
        date: null,
        term: this.$store.state.vehicle.month_diff_index,
        setDate: null,
      },

      popupMsg: '',
      activate: false,
      activateApplySurvey: false,
      activateVehicle:false,

      activateErr: false,
      vehicleSelectData: [],
      dmsVehicleData: '',
    }
  },

  filters: Format,

  methods: {
    getVehicleSelectData() {
      let selectedVehicle = this.selected.vehicle;
      let vehicleSelectData = {};

      //if (!this.pkgs[this.selected.pkg].is_assurance){
        
        for (let k_car in this.vehicleCats[this.selected.pkg]) {
          try {
            if(this.vehicleCats[this.selected.pkg][k_car].costs[this.selected.term].state) {
              //가입 가능한 패키지만 중복제거하여 수집
              vehicleSelectData = {...vehicleSelectData, ...this.vehicleCats[this.selected.pkg]};
              break;
            }
            // eslint-disable-next-line no-empty
          } catch (e){}
        }
        vehicleSelectData = Object.keys(vehicleSelectData).map((k) => { return {...vehicleSelectData[k]} });
        vehicleSelectData.sort(function (a, b) { return a.seq < b.seq ? -1 : a.seq > b.seq ? 1 : 0; });

    //  } else {
        //vehicleSelectData = [];
     // }

      if(vehicleSelectData.length === 0){
        let title = '';
        
        if(this.pkgs[this.selected.pkg].is_assurance) {
          title = '60개월 초과 ~ 96개월 이하 ';
        } else {
          title = '60개월 초과 ';
        }

        vehicleSelectData.push({title: title + "차량만 가입가능합니다.", isEmpty:true, id:0, seq:0});
        this.vehicleSelectData = vehicleSelectData;
        selectedVehicle = 0;
      } else {
        this.vehicleSelectData = vehicleSelectData;
        // 차량 기본선택

        if (selectedVehicle === 0){
          if (this.$store.state.vehicle.vehicle_cat_id !== 0){
            selectedVehicle = this.$store.state.vehicle.vehicle_cat_id;
          } else {
            selectedVehicle = this.$route.query.vehicle;
          }
        }
      }
      this.selected.vehicle = selectedVehicle;
    },

    popupClose() {
      this.activate = false;
      this.popupMsg = '';
    },

    applySurveyClose(submit){
      this.activateApplySurvey = false;

      if(submit) {
        this.$store.commit("setTerm", { insurance_survey: true });
        // this.$store.commit("setTermInsuranceServey", true); 
        this.next();
      }
    },

    vehicleSearchClose() {
      this.activateVehicle = false;
    },

    getOasVehicleInfos(vehicleVal = false) {

      this.$store.commit('setBtnLoading', true);
			
      const plusNo = this.$store.state.user.plus_no;
      const vtgNo = this.$store.state.user.vtg_no;

      axios.post(`${api.users}/getVehicles`, {
        plus_no: plusNo,
        vtg_no: vtgNo,
      }).then(({data}) => {
        if(data['data']['vehicles'].length > 0) {
          
          this.vehicleNumId.items.length = 0;

          data['data']['vehicles'].forEach( (e,i) =>{
            if(!vehicleVal) {
              if(i == 0) {
                this.selected.vehicleNumId = e.solChassisNo;
              }
            } else {
              if(vehicleVal == e.solChassisNo) {
                this.selected.vehicleNumId = e.solChassisNo;
              }
            }

            this.vehicleNumId.items.push({
              id: e.solChassisNo, 
              title: e.solChassisNo
            });
          });
        }
      }).catch(()=>{
        this.activate=true;
        this.popupMsg="차량정보를 조회 할 수 없습니다. 잠시후 다시 시도해주세요."
      });
    },

    getVehicleInfo(callback = false){

      if (!/[A-Z0-9]{17}/.test(this.selected.vehicleNumId.trim())) {
        this.activate=true;
        this.popupMsg="차량정보를 선택 해주세요."
        return;
      }

      axios.get(`${api.plus.users}/vehicle/${this.selected.vehicleNumId}` )
      .then(({data}) => {
        if (data['data'] === undefined) return;

        if (data['data']['errCode'] === '200'){
          this.activate=true;
          this.popupMsg="해당 차대번호를 조회 할수 없습니다.\n 차대번호를 확인해주세요."
          return;
        }
        if (data['data']['hasSubsc']){
          this.activate=true;
          this.popupMsg=" 이미 서비스에 가입된 차량입니다."
          return;
        }

        if(callback && typeof callback == 'function') {
          callback();
        }

      }).catch((e)=>{
        console.log(e);

        if(callback && typeof callback == 'function') {
          callback();
        }

      });
    },

    getDmsVehicleInfo(){
      if(!this.vehicleNumId.val) {
        this.activate=true;
        this.popupMsg="차대 번호를 입력해 주세요"
        return;
      }
      
      if (!/[A-Z0-9]{17}/.test(this.vehicleNumId.val.trim())) {
        this.activate=true;
        this.popupMsg="차대 번호 17자리를 모두 입력해 주세요."
        return;
      }
      
      this.$store.commit('setBtnLoading', true);
      
      const plusNo = this.$store.state.user.plus_no;
      const vtgNo = this.$store.state.user.vtg_no;

      axios.post(`${api.vehicles}/getDmsVehiclesInfo`, {
				vehicle_id: this.vehicleNumId.val,
        plus_no: plusNo,
        vtg_no: vtgNo,
        chk_vtg: true,
			}).then(({data}) => {
        
        this.dmsVehicleData = null;
          if (data['data'] === undefined) return;

          if(!data.data.result && data.data.msg) {
            this.activate=true;
            this.popupMsg= data.data.msg;
            return;
          }

          if (data['data']['serCustVehicle'] === undefined 
            || data['data']['serCustVehicle'].length === 0) {
              this.activate=true;
              this.popupMsg="입력하신 차대번호는 등록이 불가합니다."
            return;
          }

          if(data['data']['isVtgReg']) {
            this.activate=true;
            this.popupMsg="조회 결과 등록된 차대번호 입니다."
            return;
          }
          
          let idx = data['data']['serCustVehicle'].length-1;
          
          this.dmsVehicleData = data['data']['serCustVehicle'][(idx < 0 ? 0 : idx)];
          
          this.activate=true;
          this.popupMsg="차량정보가 확인되었습니다."

        }).catch(()=>{
          this.activate=true;
          this.popupMsg="차량정보를 조회 할 수 없습니다. 잠시후 다시 시도해주세요."
      });
    },

    setVehicleInfo() {

      if(this.dmsVehicleData) {
        const plusNo = this.$store.state.user.plus_no;
        const vtgNo = this.$store.state.user.vtg_no;

        this.$store.commit('setBtnLoading', true);

        axios.post(`${api.users}/addVehicle`, {
            ...this.dmsVehicleData,
            vtg_no: vtgNo,
            plus_no: plusNo,
        }).then(({data}) => {
          this.dmsVehicleData = null;

          if(!data.data.result) {
            this.activate=true;
            this.popupMsg= data.data.msg;
            return;
          }

          this.activate=true;
          this.popupMsg="차량등록이 완료되었습니다."

          //내 차량 등록 팝업 닫기
          this.activateVehicle = false;
          
          //등록 차대번호 리스트 refresh
          this.getOasVehicleInfos();

        }).catch(()=>{
          this.activate=true;
          this.popupMsg="MINI 차량은 등록할 수 없습니다." // 차량정보를 등록 할 수 없습니다. 잠시후 다시 시도해주세요
        });
      }
    },

    chkVehicleInfo(val = false){

      if(val) this.selected.vehicleNumId = val;

      this.$store.commit('setBtnLoading', true);

      const plusNo = this.$store.state.user.plus_no;

      axios.post(`${api.vehicles}/getDmsVehiclesInfo`, {
				vehicle_id: this.selected.vehicleNumId,
        plus_no: plusNo,
        chk_vtg: false,
			}).then(({data}) => {
        
        //자동으로 날짜 변경시 필요
        this.selected.term = 0;

        if(data.data.serCustVehicle.length > 0) {
          let vd = data.data.serCustVehicle[data.data.serCustVehicle.length-1];
          let typeObj = this.getVechicleTypeToId(vd);
          
          //차량 선택
          if(typeObj && typeObj.id != this.selected.vehicle) {
            this.selected.vehicle = typeObj.id;
          }
          
          this.selected.wdmsInfo = {
            ...vd,
          }
          
          if(vd && vd['carRegDt']) {
            this.selected.date = this.getDateFormat(vd['carRegDt'],'YYYY-MM-DD');
            this.selected.term = this.getVehicleNumRegMonthDiff(this.selected.date);
          }
          else this.selected.date = null;
        }

      }).catch(()=>{
        this.activate=true;
        this.popupMsg="차량정보를 조회 할 수 없습니다. 잠시후 다시 시도해주세요."
      })
    },

    getVechicleTypeToId(vd) {

      if(vd) {
        let seriesCd = (vd.seriesCd||'');
        let modelNm = (vd.modelNm||'');
        let seriesNm = (vd.seriesNm||'');

        let typeNm = 'BMW ';
        
        if(seriesCd === 'X') {
          typeNm += seriesCd + (seriesNm.indexOf('Series') == -1 ? ' Series ' : ' ') + modelNm.substr(0,2);
        } else {
          typeNm += seriesNm;
        }
        
        let tg = this.vehicleSelectData.find(e=>{
          return e.title == typeNm;
        })

        return tg;
      }

      return null;
    },

    validate() {
      if (this.pkgs[this.selected.pkg] !== undefined && this.pkgs[this.selected.pkg].is_assurance 
        && (this.selected.date === null || this.selected.date === undefined || this.selected.date === '')){
        this.activate=true;
        this.popupMsg="날짜를 입력해주세요."
        return;
      }

      if (!/[A-Z0-9]{17}/.test(this.selected.vehicleNumId.trim())) {
        this.activate=true;
        this.popupMsg="차량정보를 등록해주세요."
        return;
      }

      if(this.selected.pkg === 0) {
        this.popupMsg = '멤버십을 선택해 주세요.';
        this.activate = true;
        return;
      }

      if(this.selected.vehicle === 0) {
        this.popupMsg = '차량을 선택해 주세요.';
        this.activate = true;
        return;
      }
      
      this.getVehicleInfo(()=>{
        if(
          this.$store.state.vehicle.month_diff_index !== 'reg_date_null' &&
          this.vehicleCats[this.selected.pkg][this.selected.vehicle].costs[this.selected.term].state
        ) {

          //선택한 차량, 패키지, 금액 존재
          if(this.isAssurance) this.numRegCheck();
          else this.next();

        } else {
          // 미존재
          this.popupMsg = 'NON_MATCH_VEHICLE_PKG';
          this.activate = true;
        }
      });
    },

    closePopupErr() {
      this.activateErr = false
    },

    numRegCheck() {
      this.loading = true;

      var formData = new FormData();
      formData.append('num_reg', this.$store.state.vehicle.num_reg);

      axios.post(`${api.vehicles}/numRegCheck`, formData)
          .then(() => {
            this.activateApplySurvey = true;
          })
          .catch((error) => {
            this.loading = false;

            if (error.response.status == 409)
              this.popupMsg = error.response.data.data.msg;
            else
              this.popupMsg = this.errorMsg(error);

            this.activate = true;
          });
    },

    next() {

      this.$store.commit('setPkg', {
        id: this.pkgs[this.selected.pkg].id,
        is_assurance: this.pkgs[this.selected.pkg].is_assurance,
        price_pkg: this.costService,
        title: this.pkgs[this.selected.pkg].title,
        vehicle_cat_id: this.selected.vehicle,
      });

      this.$store.commit('setVehicle', {
        date_reg_cdk: this.selected.wdmsInfo['carRegDt'],
        num_reg_cdk: this.selected.wdmsInfo['carRegNo'],

        date_reg: this.selected.date,
        num_reg: this.selected.wdmsInfo['carRegNo'],
        num_id: this.selected.vehicleNumId,
        
        model_type: this.vehicleCats[this.selected.pkg][this.selected.vehicle].title,
        month_diff_index: this.selected.term,

        vehicle_cat_title: this.selected.wdmsInfo['seriesNm'],
        vehicle_cat_detail: this.selected.wdmsInfo['modelNm'],
        vehicle_cat_detail_desc: this.selected.wdmsInfo['pkgGrpNm'],

      });
      
      //선택 패키지가 보증상품 O
      if(this.isAssurance) {
        this.$router.push(`/subscApply/termInsurance?step=${this.step+1}`);
      }
      //선택 패키지가 보증상품 X
      else {
        this.$store.state.vehicle.km = '';
        this.$store.state.att.vehicle.panel.path = '';
        this.$router.push(`/subscApply/req?step=${this.step+1}`);
      }
    },

    // 가입 가능한 멤버십의 첫번째 맴버십 set
    setPkg() {
      if(this.selected.pkg === 0)
        this.selected.pkg = Object.keys(this.pkgs)[0];
    },

    // 선택되어있는 차량이 가입 불가능한 패키지로 변경시 선택차량 0 set
    setVehicle() {
      if(
          this.vehicleCats === undefined || this.vehicleCats[this.selected.pkg] === undefined
          || this.vehicleCats[this.selected.pkg][this.selected.vehicle] === undefined
          || !this.vehicleCats[this.selected.pkg][this.selected.vehicle].costs[this.selected.term].state
      ) this.selected.vehicle = 0;
    },

    openUsePopup(prod = null){
      this.vehicleNumId.val = null;
      if(prod) {
        //this.useData = {...prod};
        this.activateVehicle = true;
      } else {
        //Object.assign(this.$data.useData, this.$options.data().useData);
        this.activateVehicle = false;
        this.dmsVehicleData = null;
      }
    },

  },

  watch: {
    dmsVehicleData(val){
      if (val === null){
        this.vehicleNumId.description = '등록된 차량 정보가 없습니다.';
      } else {
        this.vehicleNumId.description = '';
      }
    },

    'vehicleNumId.val'(val, old){
      if (val !== old){
        this.dmsVehicleData = null;
      }
    },
    // 패키지 변경시 차량 변경 필요
    'selected.pkg'() {
      
      this.selected.date = this.selected.date === 'null'? this.selected.setDate : this.selected.date;
      
      this.setVehicle();
      this.getVehicleSelectData({type:'pkg', val:''});
    },
    
    'selected.vehicleNumId'(val) {
      this.chkVehicleInfo(val);
    },

    'selected.date'(val) {
      this.getVehicleSelectData({type:'date', val: val});
      
      this.$store.commit('setVehicle', {
        date_reg_cdk: this.selected.date,
        num_id: this.selected.vehicleNumId,
      })
    }
  },
}
</script>
